module.exports = __webpack_public_path__ + "7968928632c2b26b5ddbb38d91b4c088.pdf";